import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FlexContainer } from '@taxdown/piccolo-web';
import { Link } from 'react-router-dom';
import { isAuthenticatedSelector } from 'Store/modules/auth/selectors';
import { useFetchGetCustomers } from 'Containers/Plans/hooks';
import { publicPath, routes } from 'Constants/routes';
import {
  FRONT_PLANS,
  parsePlans,
  plansFullLogos,
  plansLogos,
  plansNameMapping,
} from 'Constants/plans';
import UpsellingButton from './components/UpsellingButton';
import SectionsButton from './components/SectionsButton';
import { AppHeaderProps } from './types';
import * as Styled from './styles';
import UserNav from './components/UserNav';

const AppHeader = ({ isFlow }: AppHeaderProps): JSX.Element => {
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  const { data } = useFetchGetCustomers(isAuthenticated);
  const plan = useMemo(
    () =>
      data && data.activePlan && isAuthenticated
        ? plansNameMapping(data.activePlan.name)
        : FRONT_PLANS.BASIC,
    [data]
  );

  const planImage = parsePlans(plan);

  return (
    <Styled.StyledHeader id="user-header">
      <FlexContainer align="center" justify="space-between">
        <SectionsButton isFlow={isFlow} />
        <FlexContainer align="center">
          {isAuthenticated ? (
            <Link to={publicPath}>
              <Styled.LogoContainer>
                <FlexContainer>
                  <img src={plansLogos[planImage]} alt="logo" />
                </FlexContainer>
                <img src={plansFullLogos[planImage]} alt="logo" />
              </Styled.LogoContainer>
            </Link>
          ) : (
            <Link to={routes.SIGNIN}>
              <img src={plansFullLogos.BASIC} alt="logo" />
            </Link>
          )}
          {isAuthenticated && <UpsellingButton plan={planImage} />}
        </FlexContainer>
        {isAuthenticated && <UserNav />}
      </FlexContainer>
    </Styled.StyledHeader>
  );
};

export default AppHeader;
